
riot.tag2('persons-company-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Контакты</div>\n    </yield>\n    <yield to="body">\n      <ul class="nav nav-tabs m-b-2">\n        <li class="{active: name == tab}" each="{tabs}"><a href="#" onclick="{tabClick}"><span>{title}</span></a></li>\n      </ul>\n      <catalog if="{tab == &quot;contacts&quot;}" name="contacts" object="Contact" cols="{contactCols}" dblclick="{submit}" search="true" reload="false" disable-col-select="1" add="{add}">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="date">{row.regDate}</datatable-cell>\n        <datatable-cell name="email">{row.email}</datatable-cell>\n        <datatable-cell name="discount">{row.discount + 0} / {row.progressiveDiscount + 0}</datatable-cell>\n      </catalog>\n      <catalog if="{tab == &quot;companies&quot;}" name="companies" object="Company" cols="{companyCols}" dblclick="{submit}" search="true" reload="false" disable-col-select="1">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="displayName">{row.name}</datatable-cell>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.item = {};
    modal.tab = 'contacts';

    modal.tabClick = function (e) {
        modal.tab = e.item.name;
    };

    modal.submit = function (e) {
        parent.opts.submit.bind(modal)();
    };

    modal.tabs = [{ name: 'contacts', title: 'Контакты' }, { name: 'companies', title: 'Компании' }];

    modal.contactCols = [{ name: 'id', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'email', value: 'Email' }, { name: 'discount', value: 'Скидка / Накоп., %' }];

    modal.companyCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

    modal.add = function () {
        modals.create('person-new-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var _this = this;
                var params = { firstName: _this.name.value, email: _this.email.value };
                API.request({
                    object: 'Contact',
                    method: 'Save',
                    data: params,
                    success: function success(response, xhr) {
                        // modals.update()
                        modal.tags[modal.tab].reload();
                        popups.create({ title: 'Успех!', text: 'Контакт добавлен!', style: 'popup-success' });
                        modal.update();
                        _this.modalHide();
                        //let e = { item: { id: response.id, }}
                        //opts.submit.bind(this)
                        //self.update()
                        //this.modalHide()
                        //if (response && response.id)
                        //self.personOpenItem(response.id)
                    }
                });
            }
        });
    };

    modal.submit = function () {
        var items = modal.tags[modal.tab].tags.datatable.getSelectedRows();
        if (!items.length) return;

        if (modal.tab == 'contacts') {
            modal.item.idAuthor = items[0].id;
            modal.item.customer = items[0].displayName;
            modal.item.idCompany = null;
        } else {
            modal.item.idCompany = items[0].id;
            modal.item.customer = items[0].name;
            modal.item.idAuthor = null;
        }
        opts.submit.bind(_this2)();
    };
});
});


// WEBPACK FOOTER //
// ./pages/persons/persons-company-list-modal.tag